export const BREADCRUMB = {
  ADD: "BREADCRUMB_ADD",
  RESET: "BREADCRUMB_RESET",
};
